import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-a5e74700"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "news-info"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "article-title"
};
const _hoisted_4 = {
  class: "article-info"
};
const _hoisted_5 = {
  class: "article-source"
};
const _hoisted_6 = {
  class: "author"
};
const _hoisted_7 = {
  class: "uptate-time"
};
const _hoisted_8 = {
  class: "article-content"
};
const _hoisted_9 = {
  key: 1,
  class: "loading"
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("加载中...");

const _hoisted_11 = {
  key: 2,
  class: "err-box"
};
import { ref } from "vue";
import { getAllData } from "../getData";
import { useRoute } from "vue-router";
export default {
  __name: 'NewsInfo',

  setup(__props) {
    // watchEffect
    //  reactive, watch
    const route = useRoute();
    let id = ref(route.params.id);
    let {
      filterNewsDataById,
      errStatus
      /*arr*/

    } = getAllData(id); // arr.value.forEach((item) => {
    //   console.log(item);
    // })
    // console.log(arr);
    // watchEffect(() => {
    //   arr.value.forEach((item) => {
    //     console.log(item);
    //   });
    // });
    // const state = ref({
    //   name: "zs",
    //   age: 15,
    //   attrObj: {
    //     attr: "efg",
    //   },
    // });
    // const state = reactive({
    //   name: "zs",
    //   age: 15,
    //   attrObj: {
    //     attr: "efg",
    //   },
    // });
    // watch(
    //   () => JSON.parse(JSON.stringify(state)), //想要获取正确的旧值 需要在监视数据的时候使用深克隆
    //   (newval, oldval) => {
    //     console.log(newval.attrObj.attr);
    //     console.log(oldval.attrObj.attr);
    //   },
    //   {
    //     deep: true,
    //   }
    // );
    // setTimeout(() => {
    //   console.log("setTimeout");
    //   state.attrObj.attr = "abc";
    // }, 1000);

    return (_ctx, _cache) => {
      const _component_lazy_component = _resolveComponent("lazy-component");

      const _component_van_loading = _resolveComponent("van-loading");

      const _component_van_empty = _resolveComponent("van-empty");

      const _directive_lazy = _resolveDirective("lazy");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(filterNewsDataById).length ? (_openBlock(), _createElementBlock("main", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterNewsDataById), item => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: item.id
        }, [_createElementVNode("header", null, [_createElementVNode("h1", _hoisted_3, _toDisplayString(item.title), 1), _createElementVNode("section", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(item.source), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, "最后更新时间:" + _toDisplayString(item.lastUpdateTime), 1)])])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.content, userObj => {
          return _openBlock(), _createElementBlock("li", {
            key: userObj.imgUrls[0]
          }, [_createVNode(_component_lazy_component, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userObj.imgUrls, imgUrl => {
              return _withDirectives((_openBlock(), _createElementBlock("img", {
                key: imgUrl
              }, null, 512)), [[_directive_lazy, imgUrl]]);
            }), 128))]),
            _: 2
          }, 1024)]);
        }), 128))])])], 64);
      }), 128))])) : _createCommentVNode("", true), !_unref(filterNewsDataById).length && !_unref(errStatus) ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_van_loading, {
        type: "spinner",
        vertical: ""
      }, {
        default: _withCtx(() => [_hoisted_10]),
        _: 1
      })])) : _createCommentVNode("", true), _unref(errStatus) ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_van_empty, {
        image: "error",
        description: "请求失败，请刷新网页重试！"
      })])) : _createCommentVNode("", true)]);
    };
  }

};